import React from 'react';

const SupportLink = () => (
  <div style={{ marginTop: '40px' }}>
    For support and feedback reach out to{' '}
    <a href="mailto:support@onboarddata.io">support@onboarddata.io</a>
  </div>
);

export default SupportLink;
